import type { ReactElement } from "react";
import ReactDOM from "react-dom";
import { formatEnergy } from "$/lib/utils/functions/marketMonitoring/graphs.functions";

export function valueOrNothing<T>(condition: boolean, value: T) {
  return condition ? value : undefined;
}

export function generateRandomId() {
  return (Math.random() + 1).toString(36).substring(7);
}

export function throttle<T extends (...params: unknown[]) => void>(
  callback: T,
  delay = 250,
) {
  let shouldWait = false;
  let waitingArgs: Parameters<T> | null = null;
  const timeoutFunc = () => {
    if (waitingArgs == null) {
      shouldWait = false;
    } else {
      callback(...waitingArgs);
      waitingArgs = null;
      setTimeout(timeoutFunc, delay);
    }
  };

  return (...args: Parameters<T>) => {
    if (shouldWait) {
      waitingArgs = args;
      return;
    }

    callback(...args);
    shouldWait = true;
    setTimeout(timeoutFunc, delay);
  };
}

export const searchForElement = (className: string, order: number) => {
  const divs = document.querySelectorAll(className);

  return divs[order];
};

export const createSpaceForComponent = (newClassName: string) => {
  const newTarget = document.createElement("div");
  newTarget.classList.add(newClassName);

  return newTarget;
};

export const addNewComponent = (component: ReactElement, target: Element) => {
  if (!component) return;

  ReactDOM.render(component, target);

  return () => {
    ReactDOM.unmountComponentAtNode(target);
  };
};

export const numberFormatter = (value: number | string) => {
  const num = formatEnergy(value, true).toString().replace(".", ",");

  return num.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
